import { makeStyles } from 'tss-react/mui';

const styles = makeStyles()(({ tokens }) => ({
  message: {
    fontSize: tokens.typography.variant.body3.fontSize,
    lineHeight: tokens.typography.variant.body3.lineHeight,
  },
}));

export default styles;
